import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';
import { ReplaySubject, BehaviorSubject } from 'rxjs';
import { Title } from '@angular/platform-browser';
@Injectable({
  providedIn: 'root'
})
export class TitleService {


  private title = new BehaviorSubject('');
  private message = new BehaviorSubject('');
  constructor(private documentTitleService: Title) {

  }
  setTitle(title: string) {
    this.title.next(title);
  }
  getTitle(): Observable<any> {
    return this.title.asObservable();
  }
  getDocumentTitle(): string {
    return this.documentTitleService.getTitle();
  }
  sendMessage(message: string) {
    this.message.next(message);
  }
  getMessage(): Observable<any> {
    return this.message.asObservable();
  }

}
